import { useState } from "react";
import LoginPage from "./pages/LoginPage";
import Sidebar from "./components/Sidebar";
import type { ViewType } from "./components/Sidebar";
import DashboardPage from "./pages/DashboardPage";
import SessionsPage from "./pages/SessionsPage";
import ChatsPage from "./pages/ChatsPage";
import UsersPage from "./pages/UsersPage";
import SettingsPage from "./pages/SettingsPage";
import { decodeToken } from "./services/auth";

export default function App() {
  const [currentView, setCurrentView] = useState<ViewType>("dashboard");
  const accessToken = localStorage.getItem("access_token");

  const tokenData = accessToken ? decodeToken(accessToken) : null;
  const isStaff = tokenData?.is_staff || false;

  if (!accessToken) {
    return <LoginPage />;
  }

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    window.location.reload();
  };

  // Solo admin ve todas las vistas; agentes ven dashboard + chats
  const actualView: ViewType = isStaff ? currentView : (currentView === "dashboard" || currentView === "chats" ? currentView : "dashboard");

  const renderView = () => {
    switch (actualView) {
      case "dashboard":
        return <DashboardPage />;
      case "sessions":
        return isStaff ? <SessionsPage /> : <DashboardPage />;
      case "chats":
        return <ChatsPage />;
      case "users":
        return isStaff ? <UsersPage /> : <DashboardPage />;
      case "settings":
        return isStaff ? <SettingsPage /> : <DashboardPage />;
      default:
        return <DashboardPage />;
    }
  };

  return (
    <div className="app-layout">
      <Sidebar currentView={currentView} onViewChange={setCurrentView} onLogout={handleLogout} isStaff={isStaff} />
      <main className="main-content">
        {renderView()}
      </main>
    </div>
  );
}